export const EnglishText = {
    language: "en",
    loginTitle: "LOGIN",
    emailPlaceholder: "Email Address",
    passwordPlaceholder: "Password",
    loginButton: "Login",
    loginProcessing: "Authenticating..",
    invalidPassword: "Invalid Password",
    invalidEmail: "Invalid User",
    loginFailed: "Login failed",
    loginBanner: "https://files.xs-global.cn/public/dedication-english-scaled.webp",
    homeWelcome: "Welcome Back ",
    homeServiceTitle1: "Admin Panel",
    homeServiceTitle2: "Technical Department",
    homeService1: "Product Management (Trading)",
    homeService2: "User Management",
    homeService3: "User Activity Log",
    homeService4: "Tutorials and Guide",
    homeService5: "Product Management (Manufacturing)",
    logout: "LOGOUT",
    appVersion: "App Version",
    breadCrumbs: "Home",

    myOffice: "My Office",
    myProfile: "My Profile",
    profileDetails: "Profile Details",
    profileName: "Name",
    profileEmployeeId: "Employee ID",
    profileEmail: "Email",
    profilePhone: "Phone",
    profileRole: "Role",
    profileDepartment: "Department",
    profilePosition: "Position",
    profileReportsTo: "Reports To",
    profileMyTasks: "My Tasks",
    profileRecentActivity: "My Recent Activity (30 Days)",
    profileTaskName: "Task Name",
    profileTaskStatus: "Status",
    profileTaskPriority: "Priority",
    profileTaskDueDate: "Due Date",
    profileActivityDate: "Date",
    profileActivityAction: "Action",
    profileActivityStatus: "Status",
    profileActivityRemarks: "Remarks",
    profileNoTasks: "No tasks found",
    profileNoActivity: "No activity found in the last 30 days",
    profileLoading: "Loading profile...",
    profileLoadError: "Unable to load profile information.",
    footerNavigation: "Office",
    quickNavigation: "Quick Navigation",
    administration: "Administration",
    myDepartment: "My Department",
    footerMyTasks: "My Tasks",
    footerTutorials: "Tutorials and Guide",
    logoutConfirmTitle: "Confirm Logout",
    logoutConfirmMessage: "Are you sure you want to log out?",
    logoutCancel: "Cancel",
    logoutConfirm: "Logout",
    loggingOut: "Logging out...",
    adminTasksTab: "Tasks",
    adminActivityTab: "Activity",
    adminCurrentMonthTasks: "Tasks This Month",
    adminUserActivity: "User Activity",
    adminTaskAssigner: "Assigner",
    adminTaskAssignee: "Assignee",
    adminPrevious: "Previous",
    adminNext: "Next",
    adminSelectDepartment: "Select department",
    adminSelectPosition: "Select position",
    adminSelectManager: "Select manager",
    adminTopOfOrganization: "Top of organization",
    adminVerified: "Verified",
    adminServiceAccess: "Service Access",
    adminYes: "Yes",
    adminNo: "No",

    // New Dashboard Texts
    websiteManagement: "Website Performance",
    last7Days: "Last 7 Days",
    last30days: "Last 30 Days",
    last90days: "Last 90 Days",
    last1year: "Last 1 Year",
    totalTraffic: "Total Traffic",
    seoTraffic: "SEO Traffic",
    socialMediaTraffic: "Social Media Traffic",
    activeUsers: "Active Users",
    organicUsers: "Organic Users",
    trafficByCountry: "Traffic By Countries",
    top10Countries: "Top 10",
    socialMedialSub: "Social Media Subscriptions",

    totalProducts: "Total Products",
    allUsers: "All Users",
    manageButton: "Manage",
    learnMoreButton: "Learn More",


    //Product PN Service Page
    pnNavMenu1: "Generate P/N",
    pnNavMenu2: "Find P/N",
    pnSelectCompany: "Select a Company",
    pnSelectCategory: "Select a Category",
    pnSelectSubCategory: "Select a Sub Category",
    pnProductImage: "Product Image",
    pnProductName:"Product Name",
    pnProductSpec: "Specifications",
    pnProductRemarks: "Remarks",
    pnProductFiles: "Datasheets/Manual",
    pnGenerateButton: "Generate P/N",

    pnAddCategoryName: "Category Name (English)",
    pnAddCategoryChineseName: "类别名称（中文）",
    pnIdentificationCode: "Identification Code",
    pnAddCategoryBtn: "Add Category",
    pnAddingData: "Adding Data",
    pnAddSubCategoryName: "Sub Category Name (English)",
    pnAddSubCategoryChineseName: "子类别名称（中文）",
    pnAddSubCategoryBtn: "Add Sub Category",
    pnAddCategoryErrorMessage : "Please add a 2-digit code with capital letters or numbers.",
    pnAddDuplicateCategoryCodeError: "Entered product PN already exists!",
    pnAddCategoryFailedError: "Failed to add error!",

    pnProductOverview: "Product Overview",
    pnCreateProductPnBtn: "Create Product P/N",
    pnCreatingProductData: "Creating data...",
    pnGeneratedProductPn: "Generated Product P/N",
    pnCopy: "Copy",
    pnCopied:"Copied",
    pnClear: "Clear",
    pnPreview: "Preview Part Numbers (Assuming serial No as X)",
    pnBaseItemTitle: "Base Item",
    pnBaseItemSub: "Leave empty to create a new serial. If a base item is provided, plating will be applied to the existing base number.",
    pnBaseItemPlaceholder: "Enter base item code (e.g. B20002 or B20002J)",


    // Product PNS Table
    pnTableTitle: "Product P/N",
    pnTableSearchPlaceHolder: "Search Product",
    pnTableSearchButton: "Search",
    pnTableHeaders: ["PN", "Product Name", "Company", "Category", "Sub Category", "Remarks"],
    pnMfgTableHeaders:["PN", "Product Name", "Product Family", "Categories", "Remarks"],


    // User Management
    // Users Table
    usersTableTitle: "All Employees",
    addUsersButton: "+ Add User",
    usersTableHeader1: "Employee ID",
    usersTableHeader2: "Name",
    usersTableHeader3: "Email",
    usersTableHeader4: "Phone",
    usersTableHeader5: "Designation",

    // View User Details
    userModalTile: "User Details",
    userRecentActivityTitle: "Recent Activity",
    deleteUserBtn: "Delete User",
    editUserBtn: "Edit User",



    // Activity Table Data
    noActivityLogFound: "No activity logs found",
    activityTableHeader1: "User Id",
    activityTableHeader2: "User Name",
    activityTableHeader3: "Action",
    activityTableHeader4: "Status",
    activityTableHeader5: "Remarks",
    activityTableHeader6: "Date",


    // Add/Edit Modal
    editImage: "Edit",
    addModalTitle: "Add User",
    editModalTitle: "Edit User",
    addEditModalParameter1: "Name",
    addEditModalParameter2: "Role",
    addEditModalParameter3: "Email",
    addEditModalParameter4: "Phone",
    addEditModalParameter5: "Password",
    addEditModalParameter6: "Service Privilege",
    addUserButton: "Add User",
    updateUserButton: "Update User",
    cancelManagingUser: "Cancel",
    updatingUser: "Updating User",
    addingUser: "Adding User",

    //Delete Modal
    deleteUserModalTitle: "Confirm Delete",
    deleteUserMessage: "Are you sure you want to delete this user?",
    deleteUserButton: "Delete",


    // Activity Log
    activityLogTitle: "User Activity Logs",
    activityLogSearchPlaceholder: "Search User Activity ...",
    activityLogId: "Log ID",
    searchButton: "Search",

    // Tutorials
    tutorialsTitle: "Tutorials & Guides",

    // Tutorial 1
    tutorial1Title: "Cloud Drive Standard Operating Procedure",
    tutorial1P1: "Our cloud drive is hosted on our personal server and designed to provide a secure and efficient platform for internal file management and sharing. This system allows users to upload, download, and organize files in a centralized environment.",
    tutorial1P2: "The platform is accessible through a web interface, making it convenient for users to access their files from anywhere. Each user is assigned specific permissions to ensure data security and proper access control.",
    tutorial1P3: "It is important to follow the standard operating procedures when using the cloud drive, including proper file naming, folder organization, and access management to maintain system efficiency and avoid data loss.",
    tutorial1P4: "For detailed instructions and step-by-step guidance, please refer to the official SOP document provided below.",
    tutorial1Btn: "Download SOP",

    // Tutorial 2
    tutorial2Title: "Office Backend Usage Guide",
    tutorial2P1: "Our office backend system is designed to help users manage internal operations, including user management, activity tracking, and service access. It provides a centralized platform for handling daily business tasks efficiently.",
    tutorial2P2: "To get started, simply log in to the system using your assigned credentials. Once logged in, you will be able to view your available services based on your assigned service privileges.",
    tutorial2P3: "Each user has different levels of access depending on their role. Make sure to explore the features available to you and utilize them to streamline your workflow and improve productivity.",
    tutorial2P4: "The system is designed to be user-friendly, so once you are logged in and familiar with your permissions, you can start using the platform immediately.",
    tutorial2Btn: "Download Guide",

    // Final Note
    tutorialFinalNote: "If you encounter any obstacles while using the system or following the tutorials, please feel free to contact us. Our team is always ready to assist you and ensure a smooth experience.",


    // Single Product
    entryDate: "Entry Date",
    entryOperator: "Entry Operator",
    modifyButton: "Modify Data",
    modifyModalTitle: "Modify Product Data",
    noAttachment: "No Attachments",
    noImage: "No Image",
    saveDataButton: "Save",
    savingDataButton: "Saving",
    deleteProduct: "Delete",
    deleteProductModalTitle: "Confirmation!",
    deleteProductMessage: "Are you sure, you want to delete this product?",
    deleteModalButton1: "Yes",
    deletingProductText: "Deleting...",
    deleteModalButton2: "No",

    // Customer Development
    customerDevelopmentHomeTitle: "Marketing Department",
    customerDevelopmentTitle: "Customer Development Platform (CDP)",
    totalCustomer: "Total Customer",
    totalCompetitor: "Total Competitors",
    totalContacted: "Total Contacted",
    totalSampleRequest: "Total Sample Request",
    totalResponded: "Total Responded",

    // Marketing Dashboard
    marketingDashboardTitle: "Marketing Dashboard",

    // Customer Profile & Contacts
    customerProfileTitle: "Customer Profile",
    addEditCustomerTitle: "Add or Edit Customer",
    addEditCustomerContactTitle: "Add or Edit Customer Contact",

    // CDP Status Labels
    cdpStatusNew: "New",
    cdpStatusNoResponse: "Contacted / No Response",
    cdpStatusResponded: "Contacted & Responded",

    // CDP Type Labels
    cdpTypeManufacturer: "Manufacturer",
    cdpTypeBoth: "Both",
    cdpTypeOEM: "OEM",

    // CDP Opportunity Labels
    cdpScoreLow: "Low",
    cdpScoreMedium: "Medium",
    cdpScoreHigh: "High",
    cdpScoreStrategic: "Strategic",
    cdpCompanyClass: "Company Class",
    cdpCompanyClassCustomer: "Customer",
    cdpCompanyClassCompetitor: "Competitor",

    // CDP Contact Status Labels
    cdpContactNoResponse: "No Response",
    cdpContactResponded: "Responded",
    cdpContactGiveUp: "Give Up",

    // CDP Supplier/Buyer
    cdpSupplier: "Supplier",
    cdpBuyer: "Buyer",

    // CDP Delivery Status
    cdpDeliveryRequested: "Requested",
    cdpDeliveryOnPrep: "On Preparation",
    cdpDeliveryDelivered: "Delivered",

    // CDP Activity Types
    cdpActivityContact: "Contact",
    cdpActivityCall: "Call",
    cdpActivityEmail: "Email",

    // CDP Last Contacted Through
    cdpLastContactedOptions: ["Email", "WhatsApp", "LinkedIn", "Phone Call", "WeChat", "Skype", "Other"],

    // CDP Form Labels
    cdpFormBasicInfo: "Basic Information",
    cdpFormSocialMedia: "Social Media",
    cdpFormProducts: "Products & Trade",
    cdpFormRemarks: "Remarks",
    cdpFormLogo: "Company Logo",
    cdpFormAttachments: "Relevant Attachments",
    cdpFormCompanyName: "Company Name",
    cdpFormCountry: "Country",
    cdpFormAddress: "Detail Address",
    cdpFormWebsite: "Website",
    cdpFormType: "Type",
    cdpFormSupplierBuyer: "Supplier / Buyer",
    cdpFormStatus: "Status",
    cdpFormOpportunity: "Opportunity Score",
    cdpFormEntryPersonnel: "Entry Personnel",
    cdpFormSampleRequested: "Sample Requested",
    cdpFormLinkedInId: "LinkedIn ID",
    cdpFormOtherSocial: "Other Social Media ID",
    cdpFormCoreProducts: "Core Products",
    cdpFormPotentialProducts: "Potential Products",
    cdpFormTotalImports: "Total Imports",
    cdpFormLastImport: "Last Import Record",
    cdpFormSave: "Save",
    cdpFormSaving: "Saving...",
    cdpFormCancel: "Cancel",
    cdpFormAddCompany: "Add New Company",
    cdpFormEditCompany: "Edit Company",
    cdpFormAddContact: "Add New Contact",
    cdpFormEditContact: "Edit Contact",

    // CDP Contact Form
    cdpContactName: "Full Name",
    cdpContactDesignation: "Designation",
    cdpContactPhone: "Phone Number",
    cdpContactEmail: "Email",
    cdpContactStatus: "Status",
    cdpContactLastThrough: "Last Contacted Through",
    cdpContactSocialMedia: "Social Media Contact",
    cdpContactLinkedIn: "Subscribed LinkedIn Page",
    cdpContactRemarks: "Remarks",
    cdpContactProfilePic: "Profile Picture",
    cdpContactCompany: "Company",

    // CDP Profile Page
    cdpEditCompany: "Edit Company",
    cdpDeleteCompany: "Delete Company",
    cdpEditContact: "Edit Contact",
    cdpDeleteContact: "Delete Contact",
    cdpTabOverview: "Overview",
    cdpTabContacts: "Contacts",
    cdpTabTrade: "Trade Data",
    cdpTabSamples: "Samples",
    cdpAddContact: "+ Add Contact",
    cdpAddTradeData: "+ Add Trade Data",
    cdpAddSample: "+ Add Sample Request",
    cdpNoContacts: "No contacts yet.",
    cdpNoTrade: "No trade data yet.",
    cdpNoSamples: "No sample requests yet.",
    cdpNoActivities: "No activities recorded yet.",
    cdpAddActivity: "+ Add Activity",
    cdpDeleteConfirmTitle: "Confirm Delete",
    cdpDeleteConfirmMsg: "Are you sure you want to delete",
    cdpDeleteBtn: "Delete",
    cdpCancelBtn: "Cancel",

    // CDP Overview Labels
    cdpLabelAddress: "Detail Address",
    cdpLabelEntryPersonnel: "Entry Personnel",
    cdpLabelCoreProducts: "Core Products",
    cdpLabelPotentialProducts: "Potential Products",
    cdpLabelLinkedInId: "LinkedIn ID",
    cdpLabelOtherSocial: "Other Social Media",
    cdpLabelSampleRequested: "Sample Requested",
    cdpLabelTotalImports: "Total Imports",
    cdpLabelLastImport: "Last Import Record",
    cdpLabelTradeNotes: "Trade Data Notes",
    cdpLabelRemarks: "Remarks",
    cdpLabelAttachments: "Attachments",
    cdpLabelSocialMedia: "Social Media",
    cdpLabelLinkedInPage: "LinkedIn Page",
    cdpLabelLastContactedThrough: "Last Contacted Through",
    cdpLabelLastContactedDate: "Last Contacted Date",
    cdpLabelCreatedDate: "Created Date",

    // Not Found Page
    notFoundTitle: "Page Not Found",
    notFoundMessage: "The page you are looking for does not exist.",
    notFoundBack: "Go Home",

    // Chat rooms
    chatroomName: "Chat Rooms",
    chatroomsAll: "All Chat rooms",
    chatroomsDescription: "Manage and view all visitor conversations across your websites",
    singleMessageName: "Single Message",


}

